<div class="d-md-flex flex-wrap justify-content-around align-items-center my-2">
    <img src="../../../assets/img/pokemon.svg" alt="">
    <div class="d-flex justify-content-around align-items-center mt-2">
        <a [routerLink]="['/home']" routerLinkActive="router-link-active"  class="btn btn-outline-secondary me-2">Home</a>
        <a [routerLink]="['/about']" routerLinkActive="router-link-active"  class="btn btn-outline-secondary">About</a>
    </div>
</div>
<hr>